import {
	jobProfileCompetencesIdDelete,
	jobProfileIdCompetencesGet,
} from "#job-profile/services/api"
import JobProfileItem from "../JobProfileItem"
import { JobProfileCompetencesFormDialog } from "./JobProfileCompetencesForm"
import { TABLE_COMPETENCIES_ITEMS } from "./JobProfileCompetenciesTable"

export default function JobProfileCompetences({ profileId, autoFetch, noEdit }) {
	return (
		<JobProfileItem
			key="competences"
			{...{
				profileId,
				autoFetch,
				tableItems: TABLE_COMPETENCIES_ITEMS,
				apiGet: jobProfileIdCompetencesGet,
				apiDelete: jobProfileCompetencesIdDelete,
				name: "",
				excluded: "competencia",
				messageDelete: (competence) => (
					<span>
						¿Está seguro de que desea eliminar la competencia{" "}
						<strong>{competence.name}</strong>?
					</span>
				),
				AddForm: JobProfileCompetencesFormDialog,
				noEdit,
			}}
		/>
	)
}
